export enum FilterTimes {
    ALL_TIMES = "ALL_TIMES",
    FUTURE_TIMES = "FUTURE_TIMES"
}

export enum FilterGroups {
    MY_GROUP = "MY_GROUP",
    ALL_GROUPS = "ALL_GROUPS"
}
